import React from "react"

import BasePermissionGate, { BasePermissionGateProps } from "@/components/PermissionGate/BasePermissionGate"

const ChatBotGroupPermissionGate = (props: Omit<BasePermissionGateProps<"chat-bot">, "feature">) => {
	return (
		<BasePermissionGate
			{...props}
			feature="chat-bot"
		/>
	)
}

export default ChatBotGroupPermissionGate
